import { Loader } from "./Loader";

export class ImageResource {

    public imageType: string;
    public alignedBuffer: ArrayBuffer;
    public size: number;
    public translucent: boolean;

    constructor(public reference: string) {
        
    }

    public get validImage() {
        return this.size > 0;
    }

    public loadBlob(dataView: DataView, loader: Loader) {
        let offset = 0;

        let mimeResult = loader.util.readString(dataView, offset);
        this.imageType = mimeResult.string;
        offset = mimeResult.offset;

        this.translucent = dataView.getUint8(offset) == 1;
        offset += 1;

        let imageSize = dataView.getInt32(offset, true);
        offset += 4;

        this.size = imageSize;

        if (imageSize > 0) {
            this.alignedBuffer = dataView.buffer.slice(dataView.byteOffset + offset, dataView.byteOffset + offset + imageSize);
        }
    }
}
